export interface CareerEntry {
  dates: string;
  role: string;
  org: string;
  desc?: string;
  bullets?: string[];
  tag?: string;
}

export const career: CareerEntry[] = [
  {
    dates: '2026 — Present',
    role: 'Co-founder',
    org: 'Glyph',
    bullets: ['Building an AI startup to define the future of {interfaces} interfaces'],
  },
  {
    dates: 'Sep 2023 — Oct 2025',
    role: 'Software Development Engineer II',
    org: 'Amazon — Sunnyvale, CA',
    bullets: [
      'Designed central data warehouse, downstream tooling for 150+ person organization, resolving cross-team reporting inconsistencies which had eroded customer trust',
      'Built service-crawler to catalogue timeout/latencies of 100,000+ service-to-service edges for Region Flexibility initiatives',
      ],
  },
  {
    dates: 'Jul 2022 — Sep 2023',
    role: 'Software Development Engineer I',
    org: 'Amazon — Sunnyvale, CA',
    bullets: [
      'Designed observability framework for [github.com/awslabs/Disco](https://github.com/awslabs/disco), used across 8,000+ Amazon services',
      'Developed [Disco](https://github.com/awslabs/disco) monitoring tooling, improving rare-failure detection from hours to minutes',
    ],
  },
  {
    dates: 'Summer 2021',
    role: 'Software Development Engineer Intern',
    org: 'Amazon - Remote',
    bullets: ['Reduced TTRC high-sev tickets by auto-correlating environment logs in Incident Response tooling'],
  },
  {
    dates: 'Spring 2020 — Spring 2022',
    role: 'Undergraduate Instructor — Intro to AI (CSCI-B351) and Discrete Structures (C241)',
    org: 'Indiana University - Bloomington, IN',
    bullets: [
      'Developed automated homework grading tool, reducing grading workload and empowering students with instant feedback',
      'Held office hours twice weekly to work closely with students on concepts discussed in class',
    ],
  },
  {
    dates: 'Summer 2019',
    role: 'Software Engineering Intern',
    org: 'Arctic Software - Remote',
    bullets: ["Increased small-business's web-driven consignment sales 5x as web/PHP developer by modernizing search UI"],
  },
];
